import React from 'react';
import { useThemeVersion } from '@raisin/components-lib';
import { BankOffersDetailProps } from './types';
import BankOffersDetailV1 from './v1/index';
import BankOffersDetailV2 from './v2/index';

const BankOffersDetail: React.FC<BankOffersDetailProps> = (props) => {
  const version = useThemeVersion();
  if (version === 'v2') {
    return <BankOffersDetailV2 {...props} />;
  }
  return <BankOffersDetailV1 {...props} />;
};

export default BankOffersDetail;
